import React from 'react';
import { Link } from 'react-router-dom';

const mockNotes = [
  { id: '1', document_id: '1', title: 'Постановление Правительства РФ от 26.12.1994 № 1426', eo_number: 'EO-1426', content: 'Важно отслеживать изменения по ставке НДС. Последнее изменение — 20% с 01.01.2019.', updated_at: '2026-05-28' },
  { id: '2', document_id: '2', title: 'Федеральный закон от 21.07.1997 № 116-ФЗ', eo_number: 'EO-116-ФЗ', content: 'Утратил силу, заменён на новый ФЗ. Не забыть проверить актуальность ссылок.', updated_at: '2026-05-25' },
];

export const NotesPage: React.FC = () => {
  return (
    <div>
      <h4 className="fw-bold mb-4">Заметки</h4>
      <div className="row g-3">
        {mockNotes.map((note) => (
          <div key={note.id} className="col-md-6">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <Link to={`/document/${note.document_id}`} className="text-decoration-none fw-medium">{note.title}</Link>
                  <span className="text-muted small font-monospace">{note.eo_number}</span>
                </div>
                <p className="text-secondary mb-2" style={{ fontSize: '14px' }}>{note.content}</p>
                <div className="text-muted" style={{ fontSize: '12px' }}>
                  <i className="bi bi-clock me-1"></i>Обновлено: {note.updated_at}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
